<template>
    <section class="panel">
        <div class="panel-heading">
            <h2 class="">Calendar<i class="clippie fa fa-info-circle" v-tooltip="'See all Portal related events, with filters'"></i></h2>
        </div>
        <div class="calendar-wrapper">
            <div class="calendar-filters">
                <ul>
                    <li><label><input type="checkbox" @change="filterEvents($event, 'assignment')" checked>Assignments</label></li>
                    <li><label><input type="checkbox" @change="filterEvents($event, 'meeting')" checked>Meetings</label></li>
                </ul>
            </div>
            <div class="clear-me"></div>
            <full-calendar
                v-if="events"
                ref="calendar"
                :key="key"
                @event-selected="selectEvent"
                :header="calendarHeader"
                :selectable="false"
                :editable="false"
                :events="events"
                :config="config">
            </full-calendar>
            <div v-else class="loader"></div>
        </div>
    </section>
</template>
<script>
import assignments from '../services/assignments';
import meetings from '../services/meetings';
import events from '../services/events';
import courses from '../services/courses';
import globalMeetings from '../services/global-meetings';
import moment from 'moment';
import toastr from 'toastr';
import { uniq } from 'lodash';

export default {
    data() {
        return {
            retries: 0,
            courses: null,
            events: null,
            eventsLoaded: false,
            noTerm: false,
            key: null,
            calendarHeader: {
                left: 'today prev,next',
                center: 'title',
                right: 'month, agendaWeek, agendaDay, listDay '
            },
            config: {
                firstDay: 1,
                defaultView: 'month',
                height: 900,
                eventRender: function(event, element) {
                    element.find('.fc-title').html(event.title);
                },
            },
            locations: [
                { id: 'green_lab', name: 'Characters for Film (Green Lab)' },
                { id: 'orange_lab', name: 'Texturing (Orange Lab)' },
                { id: 'blue_lab', name: 'Characters for Games (Blue)' },
                { id: 'fish_bowl', name: 'Fish Bowl' },
                { id: 'black_lab', name: 'Black Lab' },
                { id: 'penthouse_north', name: 'Penthouse North' },
                { id: 'penthouse_south', name: 'Penthouse South' }
            ],

        }
    },
    async mounted() {
        var self = this;
        this.populateEvents();

    },
    methods: {

        async populateEvents() {
            let events = [];
            let data = await this.getEvents();

            events = events.concat(data);


            if (this.$store.getters.courses.length > 0) {
                try {
                    data = await this.getMeetings();
                    events = events.concat(data);
                } catch(e) {
                    console.log(e)
                    console.log("COULD NOT GET MEETINGS")
                }
                try {
                    data = await this.getAssignments();
                    events = events.concat(data);
                } catch(e) {
                    console.log(e)
                    console.log("COULD NOT GET ASSIGNMENTS")
                }

            }

            if (this.$store.getters.courses.length === 0 && localStorage.terms.split(',').length === 4) {
                // mentorship student, may not have any courses per se
                data = await this.getMeetings();
                events = events.concat(data);
            }

            if (this.roles.includes('Supervisor')) {

                data = await courses.getInstructorCourses();

                const assignmentEvents = data.data.map((i) => {
                    return i.assignments.map((a) => {
                        return {
                            className: 'assignment',
                            start: a.availableDate,
                            end: a.dueDate,
                            title: a.name,
                            allDay: true,
                            link: '#'
                        }
                    });
                }).flat()

                events = events.concat(assignmentEvents);
            }

            if (this.roles.includes('CampusStudent')  || localStorage.transitioned == 'true') {
                data = await this.getCampusMeetings();
                events = events.concat(data);
            }
            if (this.roles.includes('Mentor')) {
                data = await this.getMeetings();
                events = events.concat(data);
            }

            data = await this.getGlobalMeetings();
            events = events.concat(data);

            this.events = events;

        },
        async getGlobalMeetings() {
            const response = await globalMeetings.getMine();

            const meetings = response.data.meetings.filter((m)=>{
                const participant = m.global_meeting.global_meeting_participants.find(p => p.userId == localStorage.user_id);
                if (participant.waitListed) {
                    return false;
                }
                return true;
            }).map((m)=>{
                let url = m.global_meeting.joinUrl;
                if (m.global_meeting.recordingUrl) {
                    url = m.global_meeting.recordingUrl;
                }

                const calendarObject = {
                    className: 'meeting global-meeting',
                    title: 'Global Mentorship, ' + m.global_meeting.mentor.firstName + ' ' + m.global_meeting.mentor.lastName,
                    start: moment(m.global_meeting.startTime).local().toDate(),
                    end: moment(m.global_meeting.endTime).toDate(),
                    link: url
                }

                return calendarObject;
            });

            return meetings;

        },
        getEvents() {
            var self = this;
            return events.get(this).then((response) => {
                if (response.data.success === true) {
                    return response.data.events;
                } else {
                    toastr.error("Error getting events");
                    return [];
                }

            }).catch((e)=>{
                console.log(e);
                return [];
            })
        },

        filterEvents(event, type) {
            if ($(event.currentTarget).is(':checked')) {
                $('.fc').find('.' + type).css('visibility', 'visible');
            } else {
                $('.fc').find('.' + type).css('visibility', 'hidden');
            }
        },
        selectEvent(event, jsEvent, view) {
            if (event.link) {
                window.open(event.link, '_blank');
                return false;
            }

        },
        async getCampusMeetings() {

            const response = await meetings.getCampusMeetings(this)

            let campusMeetings = response.data.meetings.filter(m => m.participants.includes(parseInt(localStorage.user_id))).map((m) => {
                let title = ''
                let location = this.locations.find(function(l) { return l.id === m.location }).name + '<br>';
                title += '<b>' + location + '</b>';

                let participants = [];
                m.participants = _.uniq(m.participants);

                m.participants.forEach((participant) => {
                    let member = response.data.participants.find(function(p) { return p.id == participant });
                    let name = member.firstName + ' ' + member.lastName;
                    if (member.roles.includes('Mentor')) name = 'Mentor: ' + name;
                    participants.push(name);
                });

                participants.sort((x, y) => { return x.includes('Mentor: ') ? -1 : y.includes('Mentor: ') ? 1 : 0; });
                title += participants.join('<br>');

                return {
                    className: "campus meeting",
                    start: moment(m.startTime).local().toDate(),
                    title: title,
                    link: null
                }
            });
            return campusMeetings;

        },
        async getAssignments() {
                const now = new Date();

                let myCourses = this.$store.getters.courses.map(function(c) {
                    return { id: parseInt(c.id), term: parseInt(c.term) };
                });


                let assignmentsResponse = await assignments.getAll(this, null, null, true)

                if (this.currentTerm && this.currentTerm.selectedCourseSet) {
                    assignmentsResponse.data.assignments = assignmentsResponse.data.assignments.filter((a) => {
                        return !a.video.course.courseSets || a.video.course.courseSets.length === 0 || a.video.course.courseSets.includes(this.currentTerm.selectedCourseSet)
                    });
                }

                var assignmentsArray = assignmentsResponse.data.assignments
                    .filter(function(a) {
                        return myCourses.findIndex(function(c) { return c.id == a.instanceId }) > -1;
                    }).map(function(a) {

                        let termId = myCourses.find(function(c) { return c.id == a.instanceId }).term;

                        const calendarObject = {
                            title: a.name,
                            start: a.availableDate,
                            end: a.dueDate,
                            className: 'assignment',
                            allDay: true,
                        }

                        if (new Date(a.availableDate) < now) {
                            calendarObject.url = window.baseUrl + '/#/course/' + termId + '/' + a.courseId + '/' + a.instanceId + '?assignment=' + a.id
                        } else {
                            calendarObject.name = calendarObject.name + 'af ' + a.availableDate
                        }

                        return calendarObject;
                    });


                return assignmentsArray;
        },
        async getMeetings() {

            const studentGroups = localStorage.group.split(',');

            let result = [];
            for (const group of studentGroups) {
                const meetingsResponse = await meetings.get(self, group);
                    var meetingsArray = meetingsResponse.data.meetings.map(function(m) {

                    let url = m.joinUrl;

                    if (m.archiveStatus === 'completed') {
                        url = m.archiveUrl;
                    }

                    let name = m.participants && m.participants.length ? 'Mentorship Session' : 'Live Q&A';
                    let title = `<a href="${url}" target="_blank">${name}</a>`;

                    if(m.secondaryRecordings && m.secondaryRecordings.length > 0) {
                        const data =  m.secondaryRecordings.map((r, i)=> {
                            return `,<a href="${r}" target="_blank" class="recording"> ${i + 2} </a>`
                        });
                       const spanHtml = data.join('');

                       if(spanHtml) {
                          title = `<a href="${url}" target="_blank">${name}</a>
                                    (
                                    <a href="${url}" target="_blank" class="recording">1</a>
                                     <span>
                                        ${spanHtml}
                                    </span>)`
                       }
                    };

                    return {
                        className: "meeting",
                        start: moment(m.startTime).local().toDate(),
                        end: moment(m.startTime).add(m.duration, 'minutes').toDate(),
                        title,
                        html: true,

                    }
                });
                result = result.concat(meetingsArray);
            }
            return result;

        },

    },
    computed: {
        roles() {
            return JSON.parse(localStorage.roles)
        },
        currentTerm() {
            return this.$store.getters.currentTerm;
        }
    }
}

</script>
<style lang="scss" scoped>

.panel {
    background-color: #222222 !important;
    //padding:20px;
}

.calendar-wrapper {
    padding: 20px;
}

</style>
<style lang="scss">

.fc-title {
    white-space:normal;
}
.fc-view {
    background: #1d1d1d;

}

.fc-widget-header {
    background: #222 !important;
}

.fc-list-view {
    border-color: #303133 !important;
}

.fc-list-item-title a {
    color: white !important;
}

.fc-today {
    background: #000 !important;
}

.fc-time-grid-event .fc-content {
    padding-bottom: 2rem;
}

.fc-content {
    color: #fff;
    font-weight: 600;
    padding: 3px;
    overflow: visible;

    a {
        text-decoration: none;
    }
}

.fc-unthemed {
    .fc-list-empty {
        background-color: #000 !important;
    }
}



.fc-event {
    border-radius: 0 !important;
    &.meeting {
        cursor:pointer;
    }
    &.global-meeting {
        font-size:11px;
    }
}



.fc-view table a {
    text-decoration: none !important;
}

.fc-day-grid-event .fc-content {
    white-space: initial;
}

.fc ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
}

.fc-time-grid .fc-slats .fc-minor td {
    border-top-style: none !important;
}

.fc-day-grid-event .fc-content {
    //white-space:inherit!important;
}

.fc-event-container a {
    border-radius: none !important;
    border: none !important;
}

.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-content,
.fc-unthemed .fc-popover {
    border-color: #303133 !important;

}

.fc-slats td,
.fc-head th,
.fc-view thead {
    border-color: #303133 !important;
}

.fc-unthemed .fc-divider,
.fc-unthemed .fc-popover .fc-header {
    background-color: #303133 !important;
}

.fc-day-header {
    padding: 1rem !important;
    background: #222;
    color: #ccc;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 2px;
}

.fc-today {
    color: white;
}

.fc button {
    background: #33ccff;
    color: #000000;
    border: #33ccff solid 1px;
    border-radius: 0 !important;
    text-shadow: none;
    padding-left: 2rem !important;
    padding-right: 2rem !important;
    box-shadow: none !important;
    text-transform: uppercase;
}

.fc-state-active {
    background: #363636 !important;
    color: white !important;
    border: solid 1px #33ccff !important;
    outline-offset: 0 !important;
}

.fc button:hover {
    background: black;
    color: white;
    border: solid 1px #33ccff;
    outline-offset: 0;
    //margin: 3px;
}

.fc .assignment {
    background: #ff4a4a !important;


    .fc-content {
        padding: 0.5rem !important;
        font-weight:600!important;
    }
}

.fc .fc-button-group>* {
    margin: 0px 0 0 3px !important;
}

.fc-center h2 {
    font-weight: 100;
}

.fc .holiday {
    background: #f7af89 !important;

    .fc-time {
        display: none;
    }
}

.fc-title a {
        color: #1a1a1a !important;
    }

.fc .meeting {
    background: #33ccff !important;
    .fc-content {
        color:#222!important;
    }
}

.fc .campus.meeting {
    background: #3cf !important;

    .fc-time,
    .fc-title {
        color: #1a1a1a !important;
    }
}

.clear-me {
    clear: both;
}

.calendar-filters {
    //display: block;
    margin: 15px 0;
    width: 100%;
    //border:solid 1px white;
    text-align: right;
    width: 100%;
    float: left;
    clear: both;

    ul {
        //width:100%;
        margin-top: -2rem;
        margin-bottom: -2rem;

        li {
            display: inline;
            margin-left: 30px;
            //width:25%;
            //float:left;
            //text-align:center;
            // margin-bottom:2rem;
        }

        label {
            input {
                margin-right: 10px;
                position: relative;
                top: 3px;
            }
        }

    }
}


.panel {
    h2 {
        background: none !important;
    }
}

.fc-widget-header {
    .fc-today {
        font-weight: 600;
    }
}
.loader {
    padding:10rem 0;
}

.recording:hover {
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// Calendar.vue?53274e58